import styled, { css } from 'styled-components'

import Icon from 'components/Icon'
import IconButton from 'components/Buttons/IconButton'
import { colors } from 'utils/colors'

export const DismissButton = styled((p) => <IconButton {...p} />)`
  border: none;

  &:active {
    box-shadow: none;
  }

  > svg {
    ${(p) => p.theme.font({ color: 'white', size: 16 })};
    width: 25px !important;
  }

  > svg:active {
    color: white;
  }

  > svg:hover,
  &:active > svg,
  &:hover > svg {
    color: ${colors.gray3};
  }
`

export const StyledIcon = styled((p) => <Icon {...p} />)`
  margin: auto;
  width: 40px !important;
`
export const DismissButtonWrapper = styled.div`
  border-left: solid 1px white;

  > div {
    height: 100%;
    display: flex;
    justify-content: center;
  }
`

export const Container = styled.div<{ color: keyof typeof colors }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  pointer-events: all;
  background-color: ${(p) => colors[p.color]};
  color: white;
  border-radius: 4px;
  height: 50px;
  min-width: 250px;
  padding: 6px 12px;
  max-width: 600px;
  ${css`
    -webkit-animation: fadein 0.5s, ease-in-out 0.5s 2.5s;
    animation: fadein 0.5s, ease-in-out 0.5s 2.5s;
  `}
  margin-top: 8px;

  @-webkit-keyframes fadein {
    from {
      top: 0;
      opacity: 0;
    }

    to {
      top: 10%;
      opacity: 1;
    }
  }

  @keyframes fadein {
    from {
      top: 0;
      opacity: 0;
    }

    to {
      top: 10%;
      opacity: 1;
    }
  }

  @-webkit-keyframes fadeout {
    from {
      top: 10%;
      opacity: 1;
    }

    to {
      top: 0;
      opacity: 0;
    }
  }

  @keyframes fadeout {
    from {
      top: 10%;
      opacity: 1;
    }

    to {
      top: 0;
      opacity: 0;
    }
  }
`

export const ContentWrapper = styled.div`
  display: flex;
  align-items: center;
`
